import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { ComponentType, forwardRef, useContext } from 'react';

import { PreferencesContext } from '@/app/providers/preferences-provider/PreferencesProvider';
import { $Subtract } from '@/shared/types/tile-packet.types';

export type ThemeName = 'light' | 'dark';

type InjectedProps = {
  theme: ThemeName;
};

function sanitizeThemeName(theme?: ThemeName | null): ThemeName {
  return theme === 'dark' ? 'dark' : 'light';
}

// react-redux doesn't work with forwardRef: https://github.com/reduxjs/react-redux/issues/914
// so this HOC always needs wrap a connect call, and a connect call cannot wrap this
export default function withThemeName<P extends InjectedProps>(
  Comp: ComponentType<P>,
): ComponentType<$Subtract<P, InjectedProps>> {
  const Result = forwardRef<unknown, $Subtract<P, InjectedProps>>(function ThemedComponent(
    props,
    ref,
  ) {
    const ctx = useContext(PreferencesContext) as any;
    const theme = sanitizeThemeName(ctx?.preferences?.theme);
    // @ts-ignore — generic ref + props pass-through
    return <Comp ref={ref} theme={theme} {...props} />;
  });

  Result.displayName = `withTheme(${Comp.displayName || Comp.name})`;
  hoistNonReactStatics(Result, Comp);
  return Result as any;
}
